import angular from 'angular';
import resource from 'angular-resource'
import appConfig from '../ConfigModule/ConfigModule';

let productCategoryResource = angular.module('cms.productCategory.resource', [resource, appConfig])
    .factory('ProductCategoryResource', function ($resource, CONFIG) {
        /** @ngInclude */

        return $resource(CONFIG.API_URL + '/productCategories', {}, {
            'findAll': {method: 'GET'}
        });
    });

export default productCategoryResource.name;


// WEBPACK FOOTER //
// ./src/cmsCore/ProductsModules/ProductCategoryResource.js